module.exports = __webpack_public_path__ + "img/cloud-sync.dc9f3ad3.svg";